import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-print-layout',
  templateUrl: './print-layout.component.html',
  styleUrls: ['./print-layout.component.scss']
})
export class PrintLayoutComponent {
  @Input() habilitado = true;

  /**
   * ✅ padrão: A4 portrait (não precisa setar)
   * Para Matriz: printBodyClass="print-a3-landscape"
   */
  @Input() printBodyClass: string | null = null;

  @Output() cancelar = new EventEmitter<void>();

  dataAtual = new Date().toLocaleDateString('pt-BR');

  constructor(public authService: AuthService) {}

 print(): void {
  const styleId = 'print-page-size-style';
  let styleEl = document.getElementById(styleId) as HTMLStyleElement | null;
  if (styleEl) styleEl.remove();

  // ✅ CORREÇÃO PRINCIPAL: remove overflow/height do modal e scroll antes de imprimir
  const modalBody = document.querySelector('.modal-body') as HTMLElement | null;
  const matrizScroll = document.querySelector('.matriz-scroll') as HTMLElement | null;
  const matDialog = document.querySelector('.mat-dialog-container') as HTMLElement | null;
  const cdkPane = document.querySelector('.cdk-overlay-pane') as HTMLElement | null;

  const prevModalBodyOverflow = modalBody?.style.cssText ?? '';
  const prevMatrizScrollOverflow = matrizScroll?.style.cssText ?? '';
  const prevMatDialog = matDialog?.style.cssText ?? '';
  const prevCdkPane = cdkPane?.style.cssText ?? '';

  if (modalBody) {
    modalBody.style.maxHeight = 'none';
    modalBody.style.overflow = 'visible';
    modalBody.style.height = 'auto';
  }
  if (matrizScroll) {
    matrizScroll.style.maxHeight = 'none';
    matrizScroll.style.overflow = 'visible';
    matrizScroll.style.height = 'auto';
  }
  if (matDialog) {
    matDialog.style.overflow = 'visible';
    matDialog.style.maxHeight = 'none';
    matDialog.style.height = 'auto';
    matDialog.style.position = 'static';
  }
  if (cdkPane) {
    cdkPane.style.overflow = 'visible';
    cdkPane.style.maxHeight = 'none';
    cdkPane.style.height = 'auto';
    cdkPane.style.position = 'static';
  }

  if (this.printBodyClass === 'print-a3-landscape') {
    styleEl = document.createElement('style');
    styleEl.id = styleId;
    styleEl.type = 'text/css';
    styleEl.media = 'print';
    styleEl.appendChild(
      document.createTextNode(`
      @page {
        size: A3 landscape !important;
        margin: 5mm !important;
      }

      html, body {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      table.page-print {
        max-width: 100% !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        table-layout: fixed !important;
      }

      table.page-print > tbody > tr > td {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }

      #th-logo,
      #th-title {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }

      .content-print {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
      }

      .modal-body,
      .matriz-scroll,
      .matriz-visualizacao {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
        max-height: none !important;
        overflow: visible !important;
        height: auto !important;
      }

      .cdk-overlay-container,
      .cdk-overlay-pane,
      .mat-dialog-container {
        all: unset !important;
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        max-height: none !important;
        position: static !important;
        transform: none !important;
        overflow: visible !important;
      }

      .matriz-tabela {
        font-size: 7.5px !important;
        width: 100% !important;
        table-layout: fixed !important;
        border-collapse: collapse !important;
        zoom: 0.85 !important;
      }

      .matriz-tabela td,
      .matriz-tabela th {
        padding: 2px 3px !important;
        line-height: 1.2 !important;
        vertical-align: top !important;
        overflow: visible !important;
        text-overflow: unset !important;
      }

      .matriz-visualizacao {
        page-break-before: always !important;
        break-before: always !important;
      }

      .matriz-visualizacao.primeira-secao {
        page-break-before: avoid !important;
        break-before: avoid !important;
      }

      .matriz-cabecalho {
        page-break-after: avoid !important;
        break-after: avoid !important;
      }

      .matriz-tabela thead {
        display: table-header-group !important;
      }

      .matriz-tabela tbody {
        display: table-row-group !important;
      }

      .matriz-tabela tr {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }

      .matriz-tabela td {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }

      .col-sit,
      .col-rec {
        min-width: unset !important;
        max-width: unset !important;
        width: 15% !important;
        word-break: break-word !important;
        overflow-wrap: break-word !important;
        white-space: pre-wrap !important;
        text-align: justify !important;
      }

      .col-causa,
      .col-efeito {
        min-width: unset !important;
        max-width: unset !important;
        width: 9% !important;
        word-break: break-word !important;
        overflow-wrap: break-word !important;
        white-space: pre-wrap !important;
      }

      .col-num-desc { width: 12% !important; }
      .col-risco    { width: 7%  !important; }
      .col-crit     { width: 9%  !important; }

      .col-ev {
        width: 14% !important;
        word-break: break-all !important;
        overflow-wrap: break-word !important;
        white-space: normal !important;
        overflow: visible !important;
      }

      .evidencia-item {
        gap: 2px !important;
        margin-bottom: 2px !important;
        width: 100% !important;
      }

      .evidencia-item span,
      .evidencia-item a {
        word-break: break-all !important;
        overflow-wrap: break-word !important;
        white-space: normal !important;
        max-width: 100% !important;
      }

      .evidencia-link {
        word-break: break-all !important;
        max-width: 100% !important;
      }

      .identificador-badge {
        background: #e8e8e8 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    `)
    );
    document.head.appendChild(styleEl);
  }

  // ✅ Pequeno delay para o DOM atualizar antes de medir e imprimir
  setTimeout(() => {
    window.print();

    // ✅ Restaura estilos originais após imprimir
    if (modalBody) modalBody.style.cssText = prevModalBodyOverflow;
    if (matrizScroll) matrizScroll.style.cssText = prevMatrizScrollOverflow;
    if (matDialog) matDialog.style.cssText = prevMatDialog;
    if (cdkPane) cdkPane.style.cssText = prevCdkPane;
  }, 300);
}
  cancelarClick() {
    this.cancelar.emit();
  }
}
